import * as React from "react";
const WeeklyMeetUpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    {...props}
  >
    <mask
      id="aWeeklyMeetUpIcon"
      width={20}
      height={21}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 .5h20v20H0z" />
    </mask>
    <g mask="url(#aWeeklyMeetUpIcon)">
      <path
        fill={props.fill}
        d="M5 13.833h6.667v-.458c0-.611-.306-1.104-.917-1.48-.61-.374-1.416-.562-2.416-.562s-1.806.188-2.417.563c-.611.375-.917.868-.917 1.479v.458ZM8.334 10.5c.458 0 .85-.163 1.177-.49.326-.326.49-.718.49-1.177 0-.458-.164-.85-.49-1.177a1.605 1.605 0 0 0-1.177-.49c-.459 0-.851.164-1.177.49-.327.327-.49.719-.49 1.177 0 .459.163.85.49 1.177.326.327.718.49 1.177.49Zm-5 6.667c-.459 0-.851-.164-1.177-.49a1.605 1.605 0 0 1-.49-1.177v-10c0-.458.163-.85.49-1.177.326-.327.718-.49 1.177-.49h10c.458 0 .85.163 1.177.49.326.326.49.719.49 1.177v3.75l3.333-3.333v9.166L15 11.75v3.75c0 .458-.163.85-.49 1.177-.326.326-.718.49-1.176.49h-10Zm0-1.667h10v-10h-10v10Z"
      />
    </g>
  </svg>
);
export default WeeklyMeetUpIcon;
